module.exports = __webpack_public_path__ + "img/javascriptlogo.a25a4d50.png";